export default __webpack_public_path__ + "static/media/indiba_deepcare.26889a6f.jpeg";